import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MessageService, ConfirmationService } from 'primeng/api';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import { TagModule } from 'primeng/tag';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

import { PaymentMethod } from '../../../shared/models/payment-method';
import { PaymentMethodService } from '../../../core/services/payment-method.service';

@Component({
  selector: 'app-payment-methods-admin',
  standalone: true,
  imports: [
    CommonModule, FormsModule, TableModule, DialogModule,
    ButtonModule, InputTextModule, RadioButtonModule,
    ToastModule, ToolbarModule, TagModule, ConfirmDialogModule
  ],
  providers: [MessageService, ConfirmationService],
  templateUrl: './payment-methods-admin.component.html',
  styleUrls: ['./payment-methods-admin.component.css']
})
export class PaymentMethodsAdminComponent implements OnInit {

  methods: PaymentMethod[] = [];
  methodDialog: boolean = false;
  method: PaymentMethod = this.getEmptyMethod();
  submitted: boolean = false;
  showImageDialog: boolean = false;
  imagePreview: string = '';

  constructor(
    private paymentService: PaymentMethodService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.loadMethods();
  }

  loadMethods() {
    this.paymentService.getAll().subscribe(data => {
      this.methods = data;
      this.cdr.detectChanges();
    });
  }

  openNew() {
    this.method = this.getEmptyMethod();
    this.submitted = false;
    this.methodDialog = true;
  }

  getEmptyMethod(): PaymentMethod {
    return {
      name: '',
      type: 'QR',
      accountNumber: '',
      holderName: '',
      qrImage: '',
      isActive: true
    };
  }

  saveMethod() {
    this.submitted = true;

    if (this.method.name.trim() && this.method.accountNumber.trim()) {
      if (this.method.type === 'QR' && !this.method.qrImage) {
        this.messageService.add({severity:'error', summary:'Error', detail:'Las billeteras requieren una URL de imagen QR.'});
        return;
      }

      this.paymentService.create(this.method).subscribe({
        next: (res) => {
          this.messageService.add({severity:'success', summary:'Éxito', detail:'Método creado correctamente'});
          this.loadMethods();
          this.methodDialog = false;
          this.method = this.getEmptyMethod();
        },
        error: () => {
          this.messageService.add({severity:'error', summary:'Error', detail:'No se pudo guardar'});
        }
      });
    }
  }

  toggleStatus(method: PaymentMethod) {
    if(method.id) {
      this.paymentService.toggle(method.id).subscribe(() => {
        method.isActive = !method.isActive;
        this.messageService.add({severity:'info', summary:'Estado', detail:'Estado actualizado'});
      });
    }
  }

  deleteMethod(method: PaymentMethod) {
    this.confirmationService.confirm({
      message: '¿Estás seguro de eliminar ' + method.name + '?',
      header: 'Confirmar',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        if(method.id) {
          this.paymentService.delete(method.id).subscribe(() => {
            this.loadMethods();
            this.messageService.add({severity:'success', summary:'Eliminado', detail:'Método eliminado'});
          });
        }
      }
    });
  }
}
